import { Box } from "@fluentui/react-northstar";
import React from "react";

import { useTeamsContext } from "../state/TeamsContextProvider";
import { isMobileClient } from "../utils/clientHelper";
import { EducationalContentAndVideosGuide } from "./EducationalContentAndVideosGuide";
import { SubscriptionStateDisplay } from "./NavBar";
import { PollyDialog } from "./PollyDialog";

type QuickWalkThroughDialogProps = {
  open: boolean;
  onClose: (completed: boolean) => void;
};
export const QuickWalkThroughDialog: React.FC<QuickWalkThroughDialogProps> = ({
  open,
  onClose,
}) => {
  const { teamsContext } = useTeamsContext();
  const isMobile = isMobileClient(teamsContext);
  return (
    <PollyDialog
      open={open}
      closeOnOutsideClick={true}
      header={<SubscriptionStateDisplay isMobile={isMobile} />}
      minWidth="340px"
      onCancel={() => {
        onClose(false);
      }}
    >
      <Box
        styles={{
          paddingTop: "2rem",
        }}
      >
        <EducationalContentAndVideosGuide />
      </Box>
    </PollyDialog>
  );
};
